/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  LoyaltyRedemptionStatus,
  SpinHistoryAdminPage,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    LoyaltyRedemptionStatusFromJSON,
    LoyaltyRedemptionStatusToJSON,
    SpinHistoryAdminPageFromJSON,
    SpinHistoryAdminPageToJSON,
} from '../models/index';

export interface GetSpinHistoryForPlayerRequest {
    playerLookupId: string;
    customerId: string;
    gameId?: string;
    status?: LoyaltyRedemptionStatus;
    resultStart?: number;
    resultEnd?: number;
    startDate?: Date;
    endDate?: Date;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class SpinToWinApi extends runtime.BaseAPI {

    /**
     * Return a paginated list of a player\'s spin history.  Defaults with all results returned in one page, but future proofed to support paginated results. Can optionally filter by the history for a particular game
     */
    async getSpinHistoryForPlayerRaw(requestParameters: GetSpinHistoryForPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SpinHistoryAdminPage>> {
        if (requestParameters['playerLookupId'] == null) {
            throw new runtime.RequiredError(
                'playerLookupId',
                'Required parameter "playerLookupId" was null or undefined when calling getSpinHistoryForPlayer().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getSpinHistoryForPlayer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['gameId'] != null) {
            queryParameters['gameId'] = requestParameters['gameId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['resultStart'] != null) {
            queryParameters['resultStart'] = requestParameters['resultStart'];
        }

        if (requestParameters['resultEnd'] != null) {
            queryParameters['resultEnd'] = requestParameters['resultEnd'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:player-spins"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/spin-to-win/{playerLookupId}/spin/history`;
        urlPath = urlPath.replace(`{${"playerLookupId"}}`, encodeURIComponent(String(requestParameters['playerLookupId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SpinHistoryAdminPageFromJSON(jsonValue));
    }

    /**
     * Return a paginated list of a player\'s spin history.  Defaults with all results returned in one page, but future proofed to support paginated results. Can optionally filter by the history for a particular game
     */
    async getSpinHistoryForPlayer(requestParameters: GetSpinHistoryForPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpinHistoryAdminPage> {
        const response = await this.getSpinHistoryForPlayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
